/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { projectedItemResponseSchema } from './projectedItemResponseSchema';

/**
 * @description Bulk fetch v2 response with projected items keyed by ID
 */
export const bulkFetchV2ResponseSchema = z
  .object({
    itemsById: z
      .object({})
      .catchall(
        z
          .lazy(() => projectedItemResponseSchema)
          .describe('A projected item. Only the requested fields are present, plus `id`.'),
      )
      .describe(
        'Map of item ID (as string) to projected item. Each entry contains only the requested fields plus `id`.',
      ),
  })
  .describe('Bulk fetch v2 response with projected items keyed by ID');
